import { render, staticRenderFns } from "./DeleteSwatch.vue?vue&type=template&id=34a51912&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a51912",
  null
  
)

export default component.exports